// extracted by mini-css-extract-plugin
export default {"fqdn":"DomainRow-fqdn_ZNHiB","badge":"DomainRow-badge_BUp6X","textRightDesktop":"DomainRow-textRightDesktop_u4TPV","item":"DomainRow-item_UpBKX"};